import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

const getErrorId = id => `${id}-error`

export const FieldError = ({ id, message }) => {
  if (!message) return null

  return (
    <p id={id} role="alert" className="mt-1 text-sm font-semibold text-red-600">
      {message}
    </p>
  )
}

export const FormField = ({
  children,
  className = '',
  error,
  id,
  label,
  required = false,
}) => (
  <div className={className || undefined}>
    <Label htmlFor={id} className="mb-2">
      {label}
      {required && <span aria-hidden="true">*</span>}
    </Label>

    {children}

    <FieldError id={getErrorId(id)} message={error} />
  </div>
)

export const FormInputField = ({
  children,
  className = 'h-11',
  error,
  id,
  label,
  name = id,
  required = false,
  wrapperClassName = '',
  ...inputProps
}) => {
  const errorId = getErrorId(id)

  return (
    <FormField
      id={id}
      label={label}
      required={required}
      error={error}
      className={wrapperClassName}
    >
      <Input
        id={id}
        name={name}
        required={required}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? errorId : undefined}
        className={className}
        {...inputProps}
      />

      {children}
    </FormField>
  )
}
